import FooterGetInTouchStrip from '../../molecules/FooterGetInTouchStrip/FooterGetInTouchStrip';
import FooterWorkTogetherBlock from '../../molecules/FooterWorkTogetherBlock/FooterWorkTogetherBlock';
import colors from '../../theme/color';

const Footer = () => {
  return (
    <footer className="relative overflow-hidden" style={{ backgroundColor: `${colors.footerDark}CC` }}>

      {/* CONTENT */}
      <div className="relative z-10">
        <FooterGetInTouchStrip />
        <FooterWorkTogetherBlock />
      </div>

    </footer>
  );
};

export default Footer;